import { Component, Inject, Injectable, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmBoxColor } from '@app/custom-shared/components/alerts/confirm-box/confirm-box.component';
import { DialogBoxService } from '@app/custom-shared/components/alerts/dialog-box-service';
import { CaceisIcons } from '@app/custom-shared/components/icons/caceis-icon/caceis-icon.component';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/create-user/store';
import { Language } from '@models/enums/language.enum';
import { Nationality } from '@models/enums/nationality.enum';
import { Store } from '@ngrx/store';
import { FeatureService } from '@services/feature/feature.service';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { UtilInputForm1 } from '../edit-user/util/util-edit-user';
import { EditMyUserModel } from './edit-my-user.model';
import { EditMyUserService } from './edit-my-user.service';
import { MsalService } from '@azure/msal-angular';
import { UserService } from '@app/core/services-api/user.service';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';

@Component({
  selector: 'app-edit-my-user',
  templateUrl: './edit-my-user.component.html',
  styleUrls: ['./edit-my-user.component.scss'],
})

@Injectable()
export class EditMyUserComponent extends ScreenComponent implements OnInit, OnDestroy {
  nationalityValues$: Observable<any>;
  languageValues$: Observable<any>;
  ddiList = [];
  user: EditMyUserModel;
  statusList = [];
  selectedStatus: string;
  utilForm1: UtilInputForm1;
  caceisIcons = CaceisIcons;
  errorInternet: string = '';

  /**
   * Default Constructor of the component
   */
  constructor(
    private userService: UserService,
    private featureService: FeatureService,
    private httpService: EditMyUserService,
    public dialogRef: MatDialogRef<EditMyUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogBoxService: DialogBoxService,
    router: Router,
    store: Store<fromMaster.State>,
    activeRoute: ActivatedRoute,
    private msalService: MsalService,
    private shared:SharedVariable
  ) {
    super(activeRoute, store, router);
  }

  async ngOnInit() {
    super.ngOnInit();

    // Criação do formulario
    this.form = this.createForm();
    this.utilForm1 = new UtilInputForm1(this.form);

    const email = this.shared.mailUser;

    // Carrega os dados do usuario
    let userJson = await this.httpService.getUserByEmail(email).toPromise();

    this.selectedStatus = userJson.status;
    this.user = userJson;
    this.updateFormValues();
  }
  updateFormValues(): void {
    if (this.user == null || this.user == undefined) return;

    this.form.get('name').setValue(this.user.name);
    this.form.get('nationality').setValue(this.user.nationality.toLowerCase());
    this.form.get('cpf').setValue(this.user.cpf);
    this.form.get('passport').setValue(this.user.passport);
    this.form.get('login').setValue(this.user.login);
    this.form.get('language').setValue(this.user.language);
    this.form.get('userSso').setValue(this.user.userSso);
    this.form.get('status').setValue(this.selectedStatus);
  }

  validateRadioButton(): void {
    if (this.islblCpfVisible()) {
      this.form.controls['cpf'].markAsTouched({ onlySelf: true });
    }

    if (this.ispassportnumberVisible()) {
      this.form.controls['passport'].markAsTouched({ onlySelf: true });
    }

    if (this.islblRgVisible()) {
      this.form.controls['rg'].markAsTouched({ onlySelf: true });
    }
  }

  /// Valida recursivamente todos os campos do form1(form)
  validateForm1(formGroup: FormGroup | FormArray): boolean {
    let isInvalid = this.form.invalid;

    if (isInvalid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);

        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateForm1(control);
        }
      });
    }
    return !isInvalid;
  }

  createForm(): FormGroup {
    return this.featureService.formBuilder.group({
      nationality: [null, []],
      cpf: [null, []],
      passport: [null, []],
      name: [null, []],
      login: [null, []],
      status: [null, []],
      language: ['português', []],
      userSso: [null, []],

    });
  }

  getNationalityValues(): Observable<any> {
    return (this.nationalityValues$ =
      this.nationalityValues$ ||
      this.featureService.translatorService.enumValues(
        Nationality,
        'Nationality',
      ));
  }

  getLanguageValues(): Observable<any> {
    return (this.languageValues$ =
      this.languageValues$ ||
      this.featureService.translatorService.enumValues(Language, 'Language'));
  }

  islblCpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality.toString().toLowerCase() != 'estrangeiro';
  }

  iscpfVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality.toString().toLowerCase() != 'estrangeiro';
    if (result !== true) {
      this.form.get('cpf').clearValidators();
      this.form.get('cpf').updateValueAndValidity();
    } else {
      this.form.get('cpf').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportnumberVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality.toString().toLowerCase() == 'estrangeiro';
  }

  ispassportVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality.toString().toLowerCase() == 'estrangeiro';
    if (result !== true) {
      this.form.get('passport').clearValidators();
      this.form.get('passport').updateValueAndValidity();
    } else {
      this.form.get('passport').setValidators([]);
    }
    return result;
  }

  islblRgVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    return nationality.toString().toLowerCase() != 'estrangeiro';
  }

  isrgVisible(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality.toString().toLowerCase() != 'estrangeiro';
    if (result !== true) {
      this.form.get('rg').clearValidators();
      this.form.get('rg').updateValueAndValidity();
    } else {
      this.form.get('rg').setValidators([Validators.required]);
    }
    return result;
  }

  ispassportRequired(): boolean {
    const nationality =
      get(this.form.value, 'nationality') || get(this.data, 'nationality');
    const result = nationality.toString().toLowerCase() == 'estrangeiro';
    if (result) {
      this.form.get('passport').setValidators([Validators.required]);
    }
    return result;
  }

  islanguageReadOnly(): boolean {
    const language =
      get(this.form.value, 'language') || get(this.data, 'language');
    return language == 'inglês';
  }

  closeWithoutAsk() {
    this.dialogRef.close();
  }

  close() {
    let titlepopup, subtitlepopup, cancelpopup, okpopup: string
    this.featureService.translatorService
      .getMessage('titleConfirm')
      .subscribe(val => {
        titlepopup = val
      })
    this.featureService.translatorService
      .getMessage('subtitleConfirm')
      .subscribe(val => {
        subtitlepopup = val
      })
    this.featureService.translatorService
      .getMessage('cancelConfirm')
      .subscribe(val => {
        cancelpopup = val
      })
    this.featureService.translatorService
      .getMessage('okConfirm')
      .subscribe(val => {
        okpopup = val
      })
      this.dialogBoxService.confirmBox({
        lblTitle: titlepopup,
        lblSubtitle: subtitlepopup,
        lblCancelButton: cancelpopup,
        lblConfirmButton: okpopup,
        color: ConfirmBoxColor.error,
      })
      .afterClosed()
      .subscribe(result => {
        if (result == true) {
          this.dialogRef.close();
        }
      });
  }

  save(): void {
if(this.form.valid){
  let titlePopUp, cancelPopUp , savePopUp : string ;
    this.featureService.translatorService.getMessage('titleEditUser').subscribe(
      val=> titlePopUp=val
    )
    this.featureService.translatorService.getMessage('cancelConfirm').subscribe(
      val=> cancelPopUp=val
    )
    this.featureService.translatorService.getMessage('saveConfirm').subscribe(
      val=> savePopUp=val
    )
  this.dialogBoxService
  .confirmBox({
    lblTitle: titlePopUp,
    lblSubtitle: ' ',
    lblCancelButton: cancelPopUp,
    lblConfirmButton: savePopUp,
    color: ConfirmBoxColor.info,
  })
  .afterClosed()
  .subscribe(result => {
    if (result == true) {
      this.user.language = this.form.get('language').value;
      this.user.userSso = this.form.get('userSso').value;
      this.userService
        .updateMyProfileRegister(this.user)
        .subscribe(response => {
          if (response.ok) {
            this.dialogRef.close(true);
            this.setUpLocalStorageLanguage(this.user.language);
            window.location.reload();
          }
        });
    }
  });
}else{
  this.featureService.validateForm(this.form)
}
 
  }

  setUpLocalStorageLanguage(selectedLanguage: string) {
    if (selectedLanguage === "português") {
      localStorage.setItem('s3brazilwebportalfe_locale_id', 'pt')
    } else {
      localStorage.setItem('s3brazilwebportalfe_locale_id', 'en')
    }
  }

  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(
      temporalType,
      datePrecision,
    );
  }

  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
